module.exports = __webpack_public_path__ + "media/svg/original_dark_vertical-3e55cf32.svg";